import { IconButton } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { type Role } from "@packsize/identity-api-sdk";
import { useState } from "react";

import { RoleConfigurationModal } from "../role-configuration-modal";

interface EditRoleButtonProps {
	readonly role: Role;
	readonly readonly: boolean;
}

export const EditRoleButton = ({ role, readonly }: EditRoleButtonProps) => {
	const [open, setOpen] = useState(false);

	return (
		<>
			<RoleConfigurationModal open={open} onClose={() => setOpen(false)} readOnly={readonly} role={role} />
			<IconButton onClick={() => setOpen(true)} data-pendoid="roles__button__edit-roles">
				{readonly ? <InfoOutlinedIcon /> : <EditOutlinedIcon />}
			</IconButton>
		</>
	);
};
